import Vue from 'vue'

import { VueLocalStorage } from '@/LocalStorage'

Vue.use(VueLocalStorage)

export const localStorage = new VueLocalStorage()
